<template>
  <div>
    <div class="container-fluid mobile-margin">
      <div class="row">
        <div class="card border-0" style="background:#ffffff00; border-radius: 15px;">
          <div class="card-body card-overdue">
            <div class="row" style="min-width:50px; top:0%;">
              <div class="col-12 text-start align-middle">
                <span style="font-size:16px; color:white;" class="text-stroke">Overdue Training</span>
              </div>
            </div>
            <div class="row">
              <div class="col text-center mx-auto" v-if="loading">
                <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
                <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
              </div>
              <table class="table mt-4 table-responsive" v-else>
                <thead>
                  <tr class="text-default">
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col tex-end"># of Training Videos</th>
                  </tr>
                </thead>
                <tbody class="align-middle" v-for="(item, index) in overdueTrainings" :key="index" style="" >
                  <tr class="text-default" style="cursor:pointer;" @click="navItemCollapse(index)" data-bs-toggle="collapse" :data-bs-target="'#overdue' + index" :aria-expanded="item.expand" aria-controls="overdue" v-tooltip.top="'Click to see overdue video details'">
                    <td>{{ item.overdue_videos.user.first_name }}</td>
                    <td>{{ item.overdue_videos.user.last_name}}</td>
                    <td class="text-start">{{ item.overdue_videos.count }}</td>
                  </tr>
                  <tr class="collapse collapse-vertical"  :class="{show: item.expand}" style="transition: opacity ease-in-out;">
                    <td colspan="4">
                      <table class="table expand">
                        <thead>
                          <tr class="text-default">
                            <th>Name</th>
                            <th>Assigned Date</th>
                          </tr>
                        </thead>
                        <tbody v-if="!loading" class="text-default">
                          <tr v-for="(item, index) in expandedData" :key="index">
                            <td  id="align-left">
                            {{ item.name }}
                            </td>
                            <td  style="width: 30%; text-align:left;">
                            {{ localFormat(item.CreatedAt) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex align-items-center justify-content-end text-default d-none d-md-flex d-sm-flex">
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 8px; font-size: 14px;">Rows per page:</span>

                <select
                  class="form-select form-select-sm shadow-none rounded-0"
                  v-model="this.pagination.rowsPerPage"
                  style="width: 5rem;"
                >
                <option class="dropdown-item" v-for="(item, index) in rowsOptions" :key="index" >
                  {{item}}
                </option>
                </select>
              </div>

              <div style="padding-right: 16px; padding-left: 16px; font-size:14px;">
                <span> {{ paginationLabel }} of {{ this.pagination.total }} </span>
              </div>
              <div>
                <a
                  @click="prev"
                  style="font-size: 14px; margin-right: 8px;"
                  :style="currPage == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                  :disabled="currPage == 1"
                >
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </a>

                <a
                  @click="next"
                  style="font-size: 14px; margin-left: 8px;"
                  :style="overdueTrainings && overdueTrainings.length < pagination.rowsPerPage ? 'color: #ccc;' : 'cursor: pointer;'"
                  :disabled="overdueTrainings && overdueTrainings.length < pagination.rowsPerPage"
                >
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
              </div>
            </div>

            <div class="d-flex d-sm-none align-items-center justify-content-between">
              <div class="d-flex align-items-center justify-content-between text-default">
                <span style="margin-right: 8px; font-size: 14px;">Rows per page:</span>
                <select
                  class="form-select form-select-sm shadow-none rounded-0"
                  v-model="this.pagination.rowsPerPage"
                  style="width: 10%;"
                >
                <option class="dropdown-item" v-for="(item, index) in rowsOptions" :key="index" >
                  {{item}}
                </option>
                </select>
              </div>
              <div class="d-inline">
                <a
                  @click="prev"
                  style="font-size: 14px; margin-right: 8px; color:#00a0c1;"
                  :style="currPage == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                  :disabled="currPage == 1"
                >
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </a>
                <span style="font-size:14px;">
                  <strong>
                    {{ paginationLabel }}
                  </strong>
                  of {{ this.pagination.total }}
                </span>
                <a
                  @click="next"
                  style="font-size: 14px; margin-left: 8px; color:#00a0c1;"
                  :style="overdueTrainings && overdueTrainings.length < pagination.rowsPerPage ? 'color: #ccc;' : 'cursor: pointer;'"
                  :disabled="overdueTrainings && overdueTrainings.length < pagination.rowsPerPage"
                >
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
       </div>
   </div>
 </template>

 <script>
import moment from 'moment';

  export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],

     data() {
        return {
          loading: false,
          overdueTrainings: [],
          quizResults: [],
          pagination:{
            rowsPerPage: 5,
            page: 1,
            total: 2,
            manager: this.isManager
          },
          rowsOptions: [5,10,15],
          expandedData: [],
          expandedIndex: -1,
      }
    },

    async created() {
      if (!this.showProduct) return

      await this.init()
    },

    methods: {
      async init(){
        this.overdueTrainings = [];
        this.quizResults = [];
        this.loading = true;

        // await this.getQuiz()
        this.getData()
      },

      getData(){
        let params = {
          limit: this.pagination.rowsPerPage,
          page: this.pagination.page,
          manager: this.pagination.manager
        }

        return new Promise((resolve, reject) => {
        this.$axios.get("/orgadmin/trainings/user/organisations/"+this.organisationID + "/overdue", {params})
        .then(response => {
          if (response.data.success) {
            this.pagination.total = response.data.total
            this.overdueTrainings = response.data.overdue_videos

            if (!this.overdueTrainings) {
              this.loading = false
              return
            }

            for (let i = 0; i < this.overdueTrainings.length; i++) {
              this.overdueTrainings[i]["expand"] = false
            }

            this.loading = false
            resolve()
          }
        }).catch(error => {
            reject(error)
          })
        })
     },


    setExpandData(item) {
      this.expandedData = item
    },

    getQuiz(){
      return new Promise((resolve, reject) => {
      this.$axios.get("/trainings/organisations/"+ this.organisationID +"/answers")
      .then(response => {
        if (response.data.success) {
          this.quizResults = response.data.quiz_results;
          resolve()
        }
      }).catch(error => {
          reject(error)
        })
      })
    },

    inArray(array, id) {
      return id in array ? array[id] : null;
    },

    prev(){
      this.pagination.page > 1 ? this.pagination.page -= 1 : ''
    },

    next() {
      this.overdueTrainings.length >= this.pagination.rowsPerPage ? this.pagination.page += 1 : ''
    },

    localFormat(date){
      return moment(date).format("LL")
    },

    navItemCollapse(index) {
      this.overdueTrainings = this.overdueTrainings.map((item, i) => {
        item.expand = !item.expand
        if (i !== index) {
          item.expand = false
        } else {
          this.expandedData = this.overdueTrainings[index].training_videos
        }
        return item
      })
    },

  },

  computed: {
    rows() {
      return this.pagination.rowsPerPage
    },

    currPage(){
      return this.pagination.page
    },

    paginationLabel() {
      var start =  Math.min((this.pagination.page - 1) * this.pagination.rowsPerPage + 1, this.pagination.total);
      var end = Math.min((this.pagination.page * this.pagination.rowsPerPage), this.pagination.total)

      return start + " - " + end
    }
  },

  watch: {
    currPage() {
      this.init()
    },

    rows() {
      this.pagination.page = 1
      this.init()
    }
  }

  }

 </script>
 <style>
 .card-overdue {
   border-radius: 15px;
   background: #ffffff;
   overflow: auto;

   background: #00a0c1; /* Old browsers */
     background: -moz-linear-gradient(top,  #00a0c1 0%, #00a0c1 50px, #ffffff 50px); /* FF3.6-15 */
     background: -webkit-linear-gradient(top,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* Chrome10-25,Safari5.1-6 */
     background: linear-gradient(to bottom,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
 }

 .pagination > li > a
  {
    background-color: white;
    color: #00a0c1;
  }

 .pagination > li > span
  {
    background-color: white;
    color: #00a0c1;
  }
 .pagination > li > span:hover
  {
    background-color: white;
    color: #00a0c1;
  }

  .text-stroke{
    text-shadow: 0 0 2px #00a0c1; /* horizontal-offset vertical-offset 'blur' colour */
    -moz-text-shadow: 0 0 2px #00a0c1;
    -webkit-text-shadow: 0 0 2px #00a0c1;
  }

  .expand tr td {
    border-top: none !important;
    border-bottom: none !important;
    font-size:14px;
  }
 </style>